export function toLocaleString(value: string | number | null) {
  if (value === null || value === undefined) {
    return null;
  }

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}
